import { alphaCheckerBackground } from '@dyl/styling/common';
import makeStyles from '@mui/styles/makeStyles';

const WIDTH = 320;
const ASPECT_RATIO = 16 / 9;

export default makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: WIDTH,

        // Ensures children do not overlap elements outside itself.
        zIndex: 0,
    },
    picker: {
        width: '100%',
        aspectRatio: ASPECT_RATIO,

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'stretch',

        background: alphaCheckerBackground,
        position: 'relative',
        overflow: 'hidden',
    },
    // fullWidth: {
    //     width: '100%',
    // },
    image: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        zIndex: 1,
        paddingLeft: theme.spacing(2),
        minHeight: 48,
        maxWidth: '100%',

        // background: '#000b',
        background: 'linear-gradient(to bottom, #0000, #000f)',
        color: theme.palette.common.white,

        // Make it easier to right-click through toolbar to image
        pointerEvents: 'none',
        '&>*': {
            pointerEvents: 'auto',
        },
    },
    labelBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        zIndex: 1,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: 48,
        maxWidth: '100%',
        marginBottom: 'auto',

        background: 'linear-gradient(to top, #0000, #000f)',
        color: theme.palette.common.white,
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        // Make it easier to right-click through toolbar to image
        pointerEvents: 'none',
        '&>*': {
            pointerEvents: 'auto',
        },
    },
    titleContainer: {
        width: 0,
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        // Make it easier to right-click through toolbar to image
        pointerEvents: 'none',
        '&>*': {
            pointerEvents: 'auto',
        },
    },
    title: {
        marginRight: 'auto',
        whiteSpace: 'nowrap',
    },

    preview: {
        display: 'block',
        width: '100%',
        maxWidth: WIDTH,
        aspectRatio: ASPECT_RATIO,
        background: alphaCheckerBackground,
        objectFit: 'contain',
        marginLeft: 'auto',
        marginRight: 'auto',
    },

    loadingWheelContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));